/**
 * participantsData.js
 * Hardcoded fallback reviews — always available even if DB/API is down.
 * All reviews default to 5 stars (Google-style display).
 * Avatars use coloured initials (no image import needed — generated via CSS).
 */

const participantsData = [
  {
    id: 1,
    name: "Joshua Olatunbosun",
    quote: "Training was delivered in an interesting and simple way. It was quite insightful.",
    rating: 5,
    link: "https://share.google/APzhEBCyPtCkALx8m"
  },
  {
    id: 2,
    name: "Christen Sattouf",
    quote: "The course was very valuable and enjoyable. We learned everything related to machine learning and deep learning, including how to use each model and when to apply it. Weekly meetings with the instructor for feedback and discussions were extremely helpful. The final projects made the concepts practical and fun.",
    rating: 5,
    link: "https://share.google/Lhnwp46VRQFZGNRH4"
  },
  {
    id: 3,
    name: "Oladele Fagbayi",
    quote: "It's a wonderful experience I had with IntElligence Tech Solutions, especially in Machine Learning and Deep Learning. I was exposed to real-time applications like predictive forex apps, movie recommendation systems, and agentic AI. I am deeply grateful to Mohammed Noman, Salman Amin, and the entire team.",
    rating: 5,
    link: "https://maps.app.goo.gl/sB8QmEoECDqXKcnL9"
  },
  {
    id: 4,
    name: "Emily Willey",
    quote: "Absolutely brilliant experience with IntElligence Tech Solutions! The hands-on projects gave me real-world skills straight away. The mentors were incredibly supportive, and the program was well-structured and industry-relevant. Highly recommend to anyone in the UK looking to break into data science!",
    rating: 5,
    link: "https://maps.app.goo.gl/16LFn2XkF7WhhnaZ7"
  },
  {
    id: 5,
    name: "Emils Bahanovskis",
    quote: "Great programme, learned a great deal, and very personable people! Weekly calls with an instructor ensured frequent feedback and rapid improvement.",
    rating: 5,
    link: "https://maps.app.goo.gl/5PnEyT3GxunTAhmk6"
  },
  {
    id: 6,
    name: "Richard Trescothick",
    quote: "Every module felt meaningful and connected to real outcomes, not just classroom work. The guidance and support were sincere, making the entire process rewarding.",
    rating: 5,
    link: ""
  },
  {
    id: 7,
    name: "Killian Higgins",
    quote: "In addition to being incredibly informative and well presented, the staff and teachers were helpful and understanding at every step. I walked away having learned a lot and would recommend it to anyone.",
    rating: 5,
    link: "https://maps.app.goo.gl/sjZRb8ptTw1EcJrJ8"
  },
  {
    id: 8,
    name: "Valarmathi Sri",
    quote: "I had a truly enriching experience during my Data Science internship. I built a full trading bot using LSTM models with measurable performance gains. Special thanks to my mentor Mohammed Noman for his patience, guidance, and encouragement.",
    rating: 5,
    link: "https://maps.app.goo.gl/W2sWr8Qp8Q69qGMKA"
  },
  {
    id: 9,
    name: "George Cunningham",
    quote: "Enrolling in the Data Science training and internship certificate program was career-changing. It transformed my understanding of real-world data science far beyond university learning. Highly recommended for anyone in the UK.",
    rating: 5,
    link: "https://maps.app.goo.gl/a59iJmpka7fRNLCP6"
  },
  {
    id: 10,
    name: "Obanla Oluwaseun",
    quote: "My internship training was a real eye-opener into professional data science. Mr. Noman broke down complex concepts clearly and prioritized industry-relevant skills. The projects truly make you employable.",
    rating: 5,
    link: "https://maps.app.goo.gl/wt12AGcUs9hGCPnf6"
  }
];

export default participantsData;